module.exports = __webpack_public_path__ + "img/zww.4110963d.png";